module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio21-58899e30668fa2a7d7603f153e4c51dd.m4a";